<div class="flex flex-col gap-4">
  @if (errorMessage) {
    <div class="p-3 bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-400 rounded-lg text-sm flex items-start gap-2">
      <i class="pi pi-exclamation-triangle mt-0.5"></i>
      <span>{{ errorMessage }}</span>
    </div>
  }

  <div class="min-h-[200px] relative">
    @if (isLoading) {
      <div class="absolute inset-0 flex flex-col items-center justify-center text-surface-400 dark:text-surface-500 gap-3 z-10">
        <i class="pi pi-spinner pi-spin text-2xl"></i>
        <span class="text-sm">Zahlungsformular wird geladen...</span>
      </div>
    }
    <div #paymentElement></div>
  </div>

  <div class="flex justify-end gap-2 pt-2">
    <p-button
      label="Abbrechen"
      [outlined]="true"
      [rounded]="true"
      (onClick)="close()"/>
    <p-button
      label="Speichern"
      [rounded]="true"
      [loading]="isSubmitting"
      [disabled]="isLoading || !!errorMessage"
      (onClick)="submit()"/>
  </div>
</div>
